var _defs, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.56 81.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke:#000;}.cls-1,.cls-4,.cls-5,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2{stroke-width:5px;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3,.cls-4{stroke-width:4px;}.cls-5,.cls-6{stroke-width:2px;}.cls-6{stroke-dasharray:7.12 7.12;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.18,14",
    transform: "translate(-0.22 -10.49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.9,20.53",
    transform: "translate(-0.22 -10.49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.52,22",
    transform: "translate(-0.22 -10.49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.45,22.93",
    transform: "translate(-0.22 -10.49)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.56,60.93a11.2,11.2,0,0,1,11.2-11.2V36.79A4.78,4.78,0,0,0,93,32H7a4.78,4.78,0,0,0-4.78,4.77V49.73a11.2,11.2,0,1,1,0,22.4V85.07A4.78,4.78,0,0,0,7,89.85H93a4.78,4.78,0,0,0,4.78-4.78V72.17A11.19,11.19,0,0,1,86.56,61Z",
    transform: "translate(-0.22 -10.49)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.88,32,82.47,12.67A4.79,4.79,0,0,1,88.37,16a.29.29,0,0,0,0,.09l4.16,16",
    transform: "translate(-0.22 -10.49)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.6,
    y1: 41.08,
    x2: 37.45,
    y2: 41.08
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.6,
    y1: 49.93,
    x2: 55.51,
    y2: 49.93
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.6,
    y1: 58.44,
    x2: 55.51,
    y2: 58.44
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 71.66,
    y1: 21.52,
    x2: 71.66,
    y2: 25.52
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 71.66,
    y1: 32.64,
    x2: 71.66,
    y2: 71.79
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 71.66,
    y1: 75.35,
    x2: 71.66,
    y2: 79.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketc);
export default __webpack_public_path__ + "static/media/ticketc.71b04ceab00e718758ebdf2b2a5bbd43.svg";
export { ForwardRef as ReactComponent };